/**
 * RS Go plateform v1.0.0 - React APPLICATION
 * Copyright 2017-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'
import SelectFormation from './formation.jsx'
import FormationInformation from './complement.jsx'
import PersonalInformation from './personnel.jsx'
import ErrorLoad from './errorLoad.jsx'
import ErrorSend from './errorSend.jsx'
import SuccesSend from './succesSend.jsx'
import axios from 'axios'
import assign from 'object-assign'
import sha1 from 'sha1'
import md5 from 'md5'
import querystring from 'querystring'
import SpinLoader from './loader.jsx'

var HttpHost = window.location.host;
var subdomainTokenGenerated = sha1(md5("X7153klU"+HttpHost));
// console.log(HttpHost)
// console.log(subdomainTokenGenerated)

var fieldValues = {
  prospect_ecole: false,
  prospect_code: false,
  prospect_type: 0,
  prospect_dob: null,
  prospect_year_code: null,
  prospect_formation_manu: false,
  prospect_formation_bateau: false,
  prospect_formation_avion: false,
  prospect_heure_conduite: false,
  prospect_heure_vol: false,
  prospect_heure_navigation: false,
  prospect_nb_heure_conduite: 0,
  prospect_nb_heure_vol: null,
  prospect_nb_heure_navigation: null,
  prospect_permis_ppl: false,
  prospect_permis_statut: null,
  prospect_preference_pass: null,
  prospect_preference_contact: null,
  prospect_message: null,
  prospect_firstname: null,
  prospect_lastname: null,
  prospect_email: null,
  prospect_phone: null,
  prospect_formation: null,
  promo_code: null
}

export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.assignFormation = this.assignFormation.bind(this)
    this.showStep = this.showStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.nextStep = this.nextStep.bind(this)
    this.saveValues = this.saveValues.bind(this);
    this.sendForm = this.sendForm.bind(this)
    this.state = {
      s: 1,
      f: false,
      ecole: false,
      agency: [],
      loadingError: true,
      sendingForm: false,
      sendForm: null
    }
  }
  componentDidMount(){
    var that = this
    this.serverRequest = axios.get(that.props.source
      +'domains?extoken='+subdomainTokenGenerated+"&exdom="+HttpHost)
      .then(function (result) {
        var agencyResponse = result.data.api.return.result
        if(agencyResponse != undefined){
          // console.log(agencyResponse);
          var agency = []
          Object.keys(agencyResponse).map(function(u, u_idx){
            agency.push({id: agencyResponse[u].domain_agency_id, name: agencyResponse[u].domain_agency_name})
          })
          // console.log(agency)
          that.setState({
            agency: agency
          })
        }else{
          that.setState({
            loadingError: true,
          })
        }
      })
      .catch(function(error){
        console.log(error)
        that.setState({
          loadingError: false
        })
      })
  }
  sendForm(e){
    var that = this

    that.setState({
      sendingForm: true
    })

    setTimeout(function(){

      Object.keys(fieldValues).map(function(key, index) {
        if(fieldValues[key] == false || fieldValues[key] == undefined || fieldValues[key] == ""){
          fieldValues[key] = 0
        }else if(fieldValues[key] == true){
          fieldValues[key] = 1
        }
      })

      var prospectData = querystring.stringify(fieldValues)
      this.serverRequest = axios.post(that.props.source
        +'prospect?extoken='+subdomainTokenGenerated+"&exdom="+HttpHost, prospectData)
        .then(function (response) {
          var postForm = response.data.api.return.attempt
          console.log("=== succes")
          console.log(response)
          if(postForm === true){
            that.setState({
              sendForm: true,
              sendingForm: false
            })
          }else if(postForm === false){
            that.setState({
              sendForm: false,
              sendingForm: false
            })
          }
        })
        .catch(function (error) {
          console.log("=== error")
          console.log(error)
          that.setState({
            sendForm: false,
            sendingForm: false
          })
        })

    }, 1500);

  }
  saveValues(field_value) {
    return function() {
      fieldValues = assign({}, fieldValues, field_value)
    }.bind(this)()
  }
  assignFormation(f_id){
    this.setState({
      f: f_id
    })
  }
  nextStep(step){
    this.setState({
      s: step+1
    })
  }
  prevStep(step){
    this.setState({
      s: step-1
    })
  }
  showStep(){
    var step = this.state.s;
    switch(step){
      case 1:
        return <SelectFormation
                  fieldValues={fieldValues}
                  assignFormation={this.assignFormation}
                  f={this.state.f}
                  next={this.nextStep}
                  saveValues={this.saveValues}/>;
        break;
      case 2:
        return <FormationInformation
                  fieldValues={fieldValues}
                  f={this.state.f}
                  next={this.nextStep}
                  prev={this.prevStep}
                  saveValues={this.saveValues}
                  agency={this.state.agency}/>;
        break;
      case 3:
        return <PersonalInformation
                  fieldValues={fieldValues}
                  f={this.state.f}
                  next={this.nextStep}
                  prev={this.prevStep}
                  saveValues={this.saveValues}
                  sendForm={this.sendForm}/>;
        break;
    }
  }
  render() {
    var render = <SpinLoader/>;
    var loading = this.state.loadingError
    if(loading == true){
      var sendForm = this.state.sendForm
      var sendingForm = this.state.sendingForm
      if(sendingForm != true){
        if(sendForm == null){
          render = <div className='container'>{this.showStep()}</div>
        }else if(sendForm == false){
          render = <ErrorSend/>
        }else if(sendForm == true){
          render = <SuccesSend/>
        }
      }else{
        render = <SpinLoader loadmessage="Enregistrement de vos réponses..."/>
      }

    }else{
      render = <ErrorLoad/>
    }
    return (render)
  }
}


// WEBPACK FOOTER //
// ./go/views/components/signup/index.jsx